import apiService from '@/utils/api-client'
import config from '@/utils/appConfig'

export default {
  getRbacRolesList({ commit }, {
    name,
    description,
    label = [],
    permissionNames = undefined,
    skip = 0,
    limit = 1000
  }) {
    try {
      return apiService.get(`rbac/roles`, { params: {
        name,
        description,
        label,
        permissionNames,
        skip,
        limit
        }, baseURL: config.VUE_APP_API_USERS_URL, })
    } catch (error) {
      console.error(error)
    }
  },

  createRole({ commit }, { name = '', description = '', label = '', roleIds = [], permissionIds = [] }) {
    try {
      return apiService.post(`rbac/roles`, {
        name,
        description,
        label,
        roleIds,
        permissionIds
      }, { baseURL: config.VUE_APP_API_USERS_URL })
    } catch (error) {
      console.error(error)
    }
  },

  updateRole({ commit }, { id, name = '', description = '', label = '', roleIds = [], permissionIds = [] }) {
    try {
      return apiService.patch(`rbac/roles/${id}`, {
        name,
        description,
        label,
        roleIds,
        permissionIds
      }, { baseURL: config.VUE_APP_API_USERS_URL })
    } catch (error) {
      console.error(error)
    }
  },

  async deleteRole({ commit }, id) {
    try {
      return apiService.delete(`rbac/roles/${id}`, {
        baseURL: config.VUE_APP_API_USERS_URL,
      })
    } catch (error) {
      console.error(error)
    }
  },

  getRbacRole({ commit }, { id }) {
    try {
      return apiService.get(`rbac/roles/${id}`, { baseURL: config.VUE_APP_API_USERS_URL, })
    } catch (error) {
      console.error(error)
    }
  },

  // eslint-disable-next-line no-unused-vars
  assignRolesToUser(_, { userId, roleIds = [] }) {
    return apiService.post(`rbac/roles/assign`, { userId, roleIds }, { baseURL: config.VUE_APP_API_USERS_URL })
  },

  getRbacPermissionsList({ commit }, { skip = 0, limit = 1000 }) {
    try {
      return apiService.get(`rbac/permissions`, { params: { skip, limit }, baseURL: config.VUE_APP_API_USERS_URL, })
    } catch (error) {
      console.error(error)
    }
  }
}
